import React, { FormEvent, Fragment, useEffect } from 'react';
import { Trans } from '@lingui/macro';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { Heading, Button } from '@mos-cat/typography';
import { Step } from '@mos-front-components/public/es/components/Steps';
import { StepProps } from '@mos-front-components/public/es/components/Steps/private/Step/Step';
import Spinner from '@mos-front-components/public/es/components/Spinner/Spinner';
import Agreements from '../Agreements/Agreements';

import PaperCertificate from '../PaperCertificate/PaperCertificate';
import { isFinalStepCompleted } from '../../../selectors/submit';
import { sendCMAFormStepChange } from '../../../helpers/CMAstats';

interface Props {
  step?: StepProps;
  complete: boolean;
  onSubmit(): FormEvent;
  disabled: boolean;
  isSubmitting: boolean;
}

function FinalStep({
  step,
  complete,
  onSubmit,
  disabled,
  isSubmitting,
}: Props) {
  useEffect(() => {
    sendCMAFormStepChange();
  }, []);

  const handleClick = () => {
    if (isSubmitting) return;
    onSubmit();
  };

  const content = disabled ? null : (
    <Fragment>
      <div className="StepContentBlock FinalStep">
        <PaperCertificate />
        <Agreements />
      </div>
      <Button primary className="FormPage__submit" onClick={handleClick}>
        {isSubmitting ? (
          <Spinner overlayVisible={false} />
        ) : (
          <Trans>Отправить заявление</Trans>
        )}
      </Button>
    </Fragment>
  );
  return (
    <Step
      className="FormPage__Step"
      step={step}
      lastStep
      completed={complete}
      disabled={disabled}
      sendStep={true}
      title={
        <Heading level={2} className="FormSteps__StepTitle">
          <Trans>Отправка заявления</Trans>
        </Heading>
      }
    >
      {content}
    </Step>
  );
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onSubmit() {
    dispatch({
      type: 'form/validate/all',
    });
  },
});

export default connect(isFinalStepCompleted, mapDispatchToProps)(FinalStep);
